import { english } from './english';
import { ukrainian } from './ukrainian';

const languages = {
  ukrainian: ukrainian,
  english: english,
};

export default languages;
